<section>
    <h3>{{ cmsData.orderSummary.containerHeader}}</h3>
    <h4 *ngIf="cmsData.orderSummary.containerSubHeader">{{ cmsData.orderSummary.containerSubHeader}}</h4>
    <div class="container" *ngFor="let planGroup of cmsData.orderSummary.planGroups">
        <div class="plan-details">
            <div class="plan-icon">
                <xm-media-image aria-hidden="true" [imageOptions]="planIcon" size="height"></xm-media-image>
            </div>
            <div class="plan-data">
                <h4 class="plan-name">{{ planGroup.planGroupHeader}}</h4>
                <div class="plan-subheader">
                    <p class="space-between">{{ planGroup.planGroupSummaryLines }}</p>
                    <p *ngIf="planGroup.strikeoutBeforePromoPrice" class="striked-subheader space-between">{{ planGroup.strikeoutBeforePromoPrice }}</p>
                    <p *ngIf="planGroup.afterPromoPrice">{{ planGroup.afterPromoPrice }}</p>
                </div>
            </div>
        </div>
        <div class="device-details" *ngFor="let device of planGroup.devices">
            <div class="device-image">
                <xm-media-image aria-hidden="true" [imageOptions]="getDeviceImage(device)"
                    size="height"></xm-media-image>
            </div>
            <div class="device-data">
                <div class="device-header">
                    <div>
                        <h4 class="device-name">{{ device.nickname}}</h4>
                        <p class="device-description">{{ device.details }}</p>
                    </div>
                    <div>
                        <p class="device-price">
                            {{ device.cost }}
                        </p>
                    </div>
                </div>
                <div class="device-charges">
                    <div class="charge-item" *ngFor="let charge of device.chargeItems">
                        <div class="charge-title">
                            <p>{{ charge.itemTitle }}</p>
                        </div>
                        <div class="charge-sub-title">
                            <p *ngIf="charge.itemSubtitle">{{ charge.itemSubtitle }}</p>
                        </div>
                        <div class="charge-badge" *ngIf="charge.badge">
                            <xm-media-image aria-hidden="true" [imageOptions]="badgeIcon(charge.badge)" size="height"></xm-media-image>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
